import React from 'react';

import './FriendsReaction.scss';
import image from '../../../../../styles/assets/icons/how-you-doing.svg';

import { TextShowcaseGroup } from '../../shared/TextShowcaseGroup/TextShowcaseGroup';

export function FriendsReaction() {
  return (
    <div className='FriendsReaction'>
      <TextShowcaseGroup isReverse={ true } areItemsCentered={ true }>
        <div className='FriendsReaction__text'>
          <p>You got them!</p>
          <p>You were right. And they were wrong.</p>
          <p>Enjoy reactions and your winner status.</p>
        </div>
        <img
          src={ image }
          className='FriendsReaction__image'
          alt='my-posts'
        />
      </TextShowcaseGroup>
    </div>
  );
}
